module.exports = (__parcel__import__("7opvE")).then(() => parcelRequire('4MKVl'));